// React imports
import { useState } from "react";
// MSAL imports
import { AuthenticatedTemplate } from "@azure/msal-react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Component Imports
import { Dashboard } from "./Dashboard";
// import { SignInButtonRedirect } from "../../components/SignInButtonRedirect";
// import { NotificationBar } from "./NotificationBar";
// import { Loading } from "../../components/Loading";
// State Import
import { useMain } from "../../state/userMainState";
// MUI Imports
import Typography from "@mui/material/Typography";
// import Stack from "@mui/material/Stack";

export function Home() {
  const [user, setUser] = useState({});
  const { isSuccess, data, isPending, isError, error } = useMain();

  // Success Function
  const successFunc = () => {
    const user = data.data.data.data.data.user;
    setUser(user);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <AuthenticatedTemplate>
        {/* {isPending && <Loading />} */}
        {isError && <Typography>Error: {error.message}</Typography>}
        {/* <Stack spacing={2}> */}
        {/* {user?.showNotificationBar === "true" && (
            <NotificationBar
              message={user?.notificationBarMessage}
              link={user?.notificationBarLink}
            />
          )} */}
        {user && <Dashboard user={user} />}
        {/* </Stack> */}
      </AuthenticatedTemplate>
    </>
  );
}
